<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="120px">
      <div class="line-box">
        <el-form-item prop="username" :label="$t('user.username')" class="styW">
          <el-input v-model="dataForm.username" :placeholder="$t('user.username')"></el-input>
        </el-form-item>
        <el-form-item prop="deptName" :label="$t('user.deptName')" class="styW">
          <ren-dept-tree v-model="dataForm.deptId" :isCall="true" :id="dataForm.id" :placeholder="$t('dept.title')" :dept-name.sync="dataForm.deptName" @deptInfo="queryInformation"></ren-dept-tree>
        </el-form-item>
        <el-form-item prop="password" :label="$t('user.password')" :class="{ 'is-required': !dataForm.id }" class="styW">
          <el-input v-model="dataForm.password" type="password" :placeholder="$t('user.password')"></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword" :label="$t('user.confirmPassword')" :class="{ 'is-required': !dataForm.id }" class="styW">
          <el-input v-model="dataForm.confirmPassword" type="password" :placeholder="$t('user.confirmPassword')"></el-input>
        </el-form-item>
        <el-form-item prop="realName" :label="$t('user.realName')" class="styW">
          <el-input v-model="dataForm.realName" :placeholder="$t('user.realName')"></el-input>
        </el-form-item>
        <el-form-item prop="gender" :label="$t('user.gender')" class="styW">
          <ren-radio-group v-model="dataForm.gender" dict-type="gender"></ren-radio-group>
        </el-form-item>
        <el-form-item prop="email" :label="$t('user.email')" class="styW">
          <el-input v-model="dataForm.email" :placeholder="$t('user.email')"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" :label="$t('user.mobile')" class="styW">
          <el-input v-model="dataForm.mobile" :placeholder="$t('user.mobile')"></el-input>
        </el-form-item>
        <el-form-item prop="roleIdList" :label="$t('user.roleIdList')" class="role-list styW">
          <el-select v-model="dataForm.roleIdList" multiple :placeholder="$t('user.roleIdList')">
            <el-option v-for="role in roleList" :key="role.id" :label="role.name" :value="role.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" :label="$t('user.status')" size="mini" class="styW">
          <el-radio-group v-model="dataForm.status">
            <el-radio :label="0">{{ $t('user.status0') }}</el-radio>
            <el-radio :label="1">{{ $t('user.status1') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="userType" label="用户" class="styW">
          <el-radio-group v-model="dataForm.userType">
            <el-radio label="INNERUSER">个人用户</el-radio>
            <el-radio label="INNERCOMPANY">企业用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="cooperationModel" label="合作模式" class="styW"  required>
          <el-radio-group v-model="dataForm.cooperationModel" :disabled="isDisabled">
            <el-radio label="PLATFORM">平台</el-radio>
            <el-radio label="INDEPENDENCE">独立资金方</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="type" label="账号类型" class="styW"  required>
          <el-radio-group v-model="dataForm.type" :disabled="isDisabled1">
            <el-radio label="PRIMARY_ACCOUNT_NUMBER">主账号</el-radio>
            <el-radio label="BYPASSACCOUNT">子账号</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from "lodash/debounce"
import { isEmail, isMobile } from "@/utils/validate"
export default {
  data() {
    return {
      isDisabled:false,
      isDisabled1:false,
      visible: false,
      roleList: [],
      roleIdListDefault: [],
      dataForm: {
        id: "",
        username: "",
        userType: "INNERCOMPANY",
        deptId: "",
        deptName: "",
        password: "",
        confirmPassword: "",
        realName: "",
        gender: 0,
        email: "",
        mobile: "",
        roleIdList: [],
        status: 1,
        cooperationModel:'',
        type:'',
      },
    }
  },
  computed: {
    dataRule() {
      var validatePassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error(this.$t("validate.required")))
        }
        callback()
      }
      var validateConfirmPassword = (rule, value, callback) => {
        if (!this.dataForm.id && !/\S/.test(value)) {
          return callback(new Error(this.$t("validate.required")))
        }
        if (this.dataForm.password !== value) {
          return callback(new Error(this.$t("user.validate.confirmPassword")))
        }
        callback()
      }
      var validateEmail = (rule, value, callback) => {
        if (value && !isEmail(value)) {
          return callback(new Error(this.$t("validate.format", { attr: this.$t("user.email") })))
        }
        callback()
      }
      var validateMobile = (rule, value, callback) => {
        if (value && !isMobile(value)) {
          return callback(new Error(this.$t("validate.format", { attr: this.$t("user.mobile") })))
        }
        callback()
      }
      return {
        username: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        deptName: [{ required: true, message: this.$t("validate.required"), trigger: "change" }],
        password: [{ validator: validatePassword, trigger: "blur" }],
        confirmPassword: [{ validator: validateConfirmPassword, trigger: "blur" }],
        realName: [{ required: true, message: this.$t("validate.required"), trigger: "blur" }],
        email: [{ validator: validateEmail, trigger: "blur" }],
        mobile: [{ required: true, message: this.$t("validate.required"), trigger: "change" },{ validator: validateMobile, trigger: "blur" }],
      }
    },
  },
  methods: {
    init() {
      this.isDisabled = false
      this.isDisabled1 = false
      this.dataForm.cooperationModel = "INDEPENDENCE"
      this.visible = true
      this.dataForm.deptId = ""
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields()
        this.roleIdListDefault = []
        Promise.all([this.getRoleList()]).then(() => {
          if (this.dataForm.id) {
            this.getInfo()
            this.isDisabled = true
            this.isDisabled1 = true
            
          }
        })
      })
    },
    queryInformation(data){
      console.log(2223,data,this.dataForm.id);
      if(this.dataForm.id){
        this.dataForm.type = "PRIMARY_ACCOUNT_NUMBER"
        this.isDisabled1 = true
      }else{
        if(data){
        this.dataForm.type = "BYPASSACCOUNT"
        this.isDisabled1 = true
        if(data.cooperationModel){
        this.dataForm.cooperationModel = data.cooperationModel
        this.isDisabled = true
        }else{
          this.dataForm.cooperationModel = "INDEPENDENCE"
          this.isDisabled = false
        }
      }else{
        this.dataForm.type = "PRIMARY_ACCOUNT_NUMBER"
        this.isDisabled1 = true
      }
      }
    },
    // 获取角色列表
    getRoleList() {
      return this.$http
        .get("/sys/role/list")
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.roleList = res.data
        })
        .catch(() => {})
    },
    // 获取信息
    getInfo() {
      this.$http
        .get(`/sys/user/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
            roleIdList: [],
          }
          // 角色配置, 区分是否为默认角色
          for (var i = 0; i < res.data.roleIdList.length; i++) {
            if (this.roleList.filter((item) => item.id === res.data.roleIdList[i])[0]) {
              this.dataForm.roleIdList.push(res.data.roleIdList[i])
              continue
            }
            this.roleIdListDefault.push(res.data.roleIdList[i])
          }
        })
        .catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false
          }
          this.$http[!this.dataForm.id ? "post" : "put"]("/sys/user", {
            ...this.dataForm,
            roleIdList: [...this.dataForm.roleIdList, ...this.roleIdListDefault],
          })
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg)
              }
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 500,
                onClose: () => {
                  this.visible = false
                  this.$emit("refreshDataList")
                },
              })
            })
            .catch(() => {})
        })
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
}
</script>

<style lang="scss">
.mod-sys__user {
  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
.styW {
  width: 320px !important;
}
.line-box {
  display: flex;
  flex-wrap: wrap;
}
</style>
